/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DocumentTypeResource = {
    AddressProof: 'ADDRESS_PROOF',
    RegistrationProof: 'REGISTRATION_PROOF',
    IdentityProof: 'IDENTITY_PROOF',
    ArticlesOfAssociation: 'ARTICLES_OF_ASSOCIATION',
    ShareholderDeclaration: 'SHAREHOLDER_DECLARATION',
    SocialContributionsCertificate: 'SOCIAL_CONTRIBUTIONS_CERTIFICATE',
    ContractOfAdhesion: 'CONTRACT_OF_ADHESION',
    DeclarationOfNonRegularActivity: 'DECLARATION_OF_NON_REGULAR_ACTIVITY',
    UboCertificate: 'UBO_CERTIFICATE',
    SelfEmploymentCertificate: 'SELF_EMPLOYMENT_CERTIFICATE'
} as const;
export type DocumentTypeResource = typeof DocumentTypeResource[keyof typeof DocumentTypeResource];


export function instanceOfDocumentTypeResource(value: any): boolean {
    for (const key in DocumentTypeResource) {
        if (Object.prototype.hasOwnProperty.call(DocumentTypeResource, key)) {
            // @ts-ignore
            if (DocumentTypeResource[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DocumentTypeResourceFromJSON(json: any): DocumentTypeResource {
    return DocumentTypeResourceFromJSONTyped(json, false);
}

export function DocumentTypeResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentTypeResource {
    return json as DocumentTypeResource;
}

export function DocumentTypeResourceToJSON(value?: DocumentTypeResource | null): any {
    return value as any;
}

